"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/policyHolderSelectionRoutes',["require", "exports"], function (require, exports) {
    "use strict";

    var PolicyHolderSelectionRoutes = function () {
        function PolicyHolderSelectionRoutes() {
            _classCallCheck(this, PolicyHolderSelectionRoutes);

            this.policyHolderSelectionPrefix = '/api/PolicyHolderInfo/';
            this.getAccidentAndIncidentSummaryUrl = this.getApiControllerUrl("GetAccidentAndIncidentSummary");
            this.getAccidentAndIncidentChartDataUrl = this.getApiControllerUrl("GetAccidentAndIncidentChartData");
            this.getAccidentsAndIncidentsGridDataUrl = this.getApiControllerUrl("GetAccidentsAndIncidentsGridData");
            this.getIncidentSummaryUrl = this.getApiControllerUrl("GetIncidentSummary");
            this.getIncidentChartDataUrl = this.getApiControllerUrl("GetIncidentChartData");
            this.getIncidentsGridDataUrl = this.getApiControllerUrl("GetIncidentsGridData");
            this.getAccidentsAndIncidentsDataThisWeekUrl = this.getApiControllerUrl("GetAccidentsAndIncidentsDataThisWeek");
            this.getAccidentsAndIncidentsDataThisMonthUrl = this.getApiControllerUrl("GetAccidentsAndIncidentsDataThisMonth");
            this.getAccidentsAndIncidentsDataThisYearUrl = this.getApiControllerUrl("GetAccidentsAndIncidentsDataThisYear");
            this.getIncidentsDataThisWeekUrl = this.getApiControllerUrl("GetIncidentsDataThisWeek");
            this.getIncidentsDataThisMonthUrl = this.getApiControllerUrl("GetIncidentsDataThisMonth");
            this.getIncidentsDataThisYearUrl = this.getApiControllerUrl("GetIncidentsDataThisYear");
            this.saveAccidentReportUrl = this.getApiControllerUrl("SaveAccidentReport");
            this.sendRebuildFromDateRequestUrl = this.getApiControllerUrl("SendRebuildFromDateRequest");
            this.getPolicyHolderByImeiUrl = this.getApiControllerUrl("GetPolicyHolderByImei");
            this.getPolicyHolderByPolicyIdUrl = this.getApiControllerUrl("GetPolicyHolderByPolicyId");
            this.getPolicyHolderByDeviceIdUrl = this.getApiControllerUrl("GetPolicyHolderByDeviceId");
            this.getPoliciesForUserUrl = this.getApiControllerUrl("GetPoliciesForUser");
            this.getMidweightPoliciesByClientIdUrl = this.getApiControllerUrl("GetMidweightPoliciesByClientId");
            this.getMidweightPolicyByBrokerPolicyIdUrl = this.getApiControllerUrl("GetMidweightPolicyByBrokerPolicyId");
            this.getMidweightPolicyByBillingRefUrl = this.getApiControllerUrl("GetMidweightPolicyByBillingRef");
            this.getMidweightPolicyByPolicyIdUrl = this.getApiControllerUrl("GetMidweightPolicyByPolicyId");
            this.getMidweightPoliciesByVehicleRegUrl = this.getApiControllerUrl("GetMidweightPoliciesByVehicleReg");
            this.getMidweightPoliciesByImeiUrl = this.getApiControllerUrl("GetMidweightPoliciesByImei");
            this.getMidweightPoliciesByUnitSerialNumberUrl = this.getApiControllerUrl("GetMidweightPoliciesByUnitSerialNumber");
            this.getLastKnownPositionForImeiUrl = this.getApiControllerUrl("GetLastKnownPositionForImei");
            this.updateRiskLatLngUrl = this.getApiControllerUrl("UpdateRiskLatLng");
            this.requestDeviceReplacementUrl = this.getApiControllerUrl("RequestDeviceReplacement");
            this.fetchDeviceReplacementRequestsUrl = this.getApiControllerUrl("FetchDeviceReplacementRequests");
            this.getLatestUserActivityDatesUrl = this.getApiControllerUrl("GetLatestUserActivityDates");
            this.getAverageLocationRequestUrl = this.getApiControllerUrl("GetAverageLocation");
            this.getFullPolicyDetailsUrl = this.getApiControllerUrl("GetFullPolicyDetails");
            this.getAllPoliciesForPolicyHolderUrl = this.getApiControllerUrl("GetAllPoliciesForPolicyHolder");
            this.getAllVehiclesForPolicyUrl = this.getApiControllerUrl("GetAllVehiclesForPolicy");
            this.getAllAddressesForPolicyHolderUrl = this.getApiControllerUrl("GetAllAddressesForPolicyHolder");
            this.getPolicyHistoryUrl = this.getApiControllerUrl("GetPolicyHistory");
            this.getAddressHistoryUrl = this.getApiControllerUrl("GetAddressHistory");
            this.getAlertSummaryUrl = this.getApiControllerUrl("GetAlertSummary");
            this.getPolicyHolderHistoryUrl = this.getApiControllerUrl("GetPolicyHolderHistory");
            this.getInitialiseUrl = this.getApiControllerUrl("Initialise");
            this.getDeviceDataForImeiUrl = this.getApiControllerUrl("GetDeviceDataForImei");
            this.getLatestSummaryUrl = this.getApiControllerUrl("GetLatestSummary");
            this.rebuildAllJourneysForImeiUrl = this.getApiControllerUrl("RebuildAllJourneysForImei");
            this.updatePolicyVehicleUrl = this.getApiControllerUrl("UpdatePolicyVehicle");
            this.deletePolicyVehicleUrl = this.getApiControllerUrl("DeletePolicyVehicle");
            this.updateDeviceAllocationUrl = this.getApiControllerUrl("UpdateDeviceAllocation");
            this.deleteDeviceAllocationUrl = this.getApiControllerUrl("DeleteDeviceAllocation");
        }

        _createClass(PolicyHolderSelectionRoutes, [{
            key: "getApiControllerUrl",
            value: function getApiControllerUrl(path) {
                return this.policyHolderSelectionPrefix + path;
            }
        }, {
            key: "getApiControllerUrlWithQuery",
            value: function getApiControllerUrlWithQuery(path, returnUrl, generateState) {
                return this.getApiControllerUrl(path) + this.urlQueryString(returnUrl, generateState);
            }
        }, {
            key: "urlQueryString",
            value: function urlQueryString(returnUrl, generateState) {
                return "?returnUrl=" + encodeURIComponent(returnUrl) + "&generateState=" + (generateState ? "true" : "false");
            }
        }]);

        return PolicyHolderSelectionRoutes;
    }();

    return new PolicyHolderSelectionRoutes();
});
//# sourceMappingURL=policyHolderSelectionRoutes.js.map;
